import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const SideBarMenuItem = ({ routeName, icon, name, children, extraClass = '' }) => {
    const [menuOpen, setMenuOpen] = useState(false);

    if (children) {
        return (
            <li className={`ddwoms-nav-item${menuOpen ? ' open' : ''}`}>
                <div
                    className={`ddwoms-nav-link ${extraClass}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <i className={icon} />
                    <span>{name}</span>
                    <i className="fas fa-angle-left nav-arrow" />
                </div>
                <ul className="ddwoms-submenu">
                    {children}
                </ul>
            </li>
        );
    }

    return (
        <li className="ddwoms-nav-item">
            <NavLink
                className={({ isActive }) =>
                    `ddwoms-nav-link ${extraClass}${isActive ? ' active-link' : ''}`
                }
                to={routeName || '/'}
                title={name}
            >
                <i className={icon} />
                <span>{name}</span>
            </NavLink>
        </li>
    );
};

export default SideBarMenuItem;
